import React from 'react';
import cx from 'classnames';
import picture from '../../assets/img/moi.webp';
import style from './Picture.module.css';

/**
 * Displays an image of me for Tablet or big phones.
 *
 * @returns Image
 */
function MobilePicture() {
  return (
    <img
      src={picture}
      className={cx(
        style.mainImgMobile,
        'img-fluid d-none d-sm-block d-lg-none',
      )}
      alt="me"
      width="294"
      height="274"
    />
  );
}

export default MobilePicture;
